export function openUrl(url: string, target: '_blank' | '_self' = '_blank'): void {
    window.open(url, target);
}

export function openPopup(url: string, name: string, windowFeatures: string): Window | null {
    return window.open(url, name, windowFeatures);
}

export function reloadPage(): void {
    window.location.reload();
}
